import { render, staticRenderFns } from "./CardRowTab.vue?vue&type=template&id=5e3df37c&"
import script from "./CardRowTab.vue?vue&type=script&lang=js&"
export * from "./CardRowTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports